import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToWorkspaceAttention,
  type WorkspaceAttention,
  type WorkspaceAttentionApiResource,
} from './attentionApi.types';

export async function fetchWorkspaceAttention(clientId: string | null): Promise<WorkspaceAttention> {
  const response = await httpClient.get<WorkspaceAttentionApiResource>('/me/workspace/attention', {
    params: { client_id: clientId === null ? undefined : clientId },
  });
  return mapApiResourceToWorkspaceAttention(response.data);
}
